import React from 'react';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

export const PagoCanceladoRec = (data) => {
    const {topup_amount,mdn} = data;
    const history = useHistory();

    const regresaRecarga = () =>{
        history.push("/recarga");
    }


    return (
        <>
    <Helmet>
        <title>Recargas Unefon</title>
      </Helmet>
      <div className='contenedorTicket'>
          <div className='parte1'>
              <div className='iconoError'></div>
              <div className='tituloTicket'>Operación cancelada</div>
              
              <div className='cantidadPagada'>${topup_amount}.00</div>
              <p>Cancelaste tu recarga</p>
          </div>
          <div className='parte2'>
              <div className='contNum'>
                  <span className='icoCel'></span>
                  <span className='textoIco'>{mdn}</span>
              </div>
          </div>
          <div onClick={regresaRecarga} className='button button--telesto'><span>Recarga otro número</span></div>
      </div>
      </>
    )
}